import { FeaturedGif4, FeaturedGif5, FeaturedGif6 } from '@/assets/images'
import { LeafBlue, LeafRed, LeafYellow } from '@/assets/svg'
import { ClaimSection } from '@/components/sections/claim-section'
import { CompaniesSection } from '@/components/sections/companies-section'
import { FeaturedItem } from '@/components/sections/featured-item'
import { HeroSection } from '@/components/sections/hero-section'
import { JobsSection } from '@/components/sections/jobs-section'
import { RecruitersSection } from '@/components/sections/recruiters-section'
import { env } from '@/config/env'

export function EmployerPage() {
  return (
    <div className="employer-page">
      <HeroSection
        isEmployer
        title={
          <>
            Dream big.
            <br />
            Hire big.
          </>
        }
        description="Brightsource helps startups reach the right talent, respond faster, and create an excellent candidate experience every time."
      />

      <CompaniesSection />
      <EmployerFeatured />
      <RecruitersSection />
      <JobsSection />
      <ClaimSection />
    </div>
  )
}

// "Find talents" was a dead button in legacy (no href, no handler); it links where the page's
// other employer CTAs go — the talent app root, exactly the base legacy's live employer CTAs
// used. See docs/features/landing-coverage.md, "Outbound links".
function EmployerFeatured() {
  return (
    <section className="employer-featured">
      <div className="employer-featured-inner container">
        <FeaturedItem
          isEmployer
          reverse
          title="Scale your team"
          description="8 million startup-ready candidates"
          buttonText="Find talents"
          buttonHref={env.talentAppUrl}
          imgSrc={FeaturedGif4}
        >
          <div className="featured-item-group">
            <div className="featured-item-row">
              <img src={LeafYellow} alt="" />
              <div>
                <label>Top tech talent</label>
                <p>Engineers, PMs, designers, sales, & marketing</p>
              </div>
            </div>

            <div className="featured-item-row">
              <img src={LeafRed} alt="" />
              <div>
                <label>Worldwide focus</label>
                <p>Local & remote candidates in the US and abroad</p>
              </div>
            </div>

            <div className="featured-item-row">
              <img src={LeafBlue} alt="" />
              <div>
                <label>Startup-ready</label>
                <p>Candidates on our platform are specifically interested in startups</p>
              </div>
            </div>
          </div>
        </FeaturedItem>

        <FeaturedItem
          isEmployer
          title="We’ve improved every aspect of hiring"
          description="Discover jobs before everyone else and follow the recruitment process online easily and transparently until you find the job of your dreams."
          buttonText="Find talents"
          buttonHref={env.talentAppUrl}
          imgSrc={FeaturedGif5}
        />

        <FeaturedItem
          isEmployer
          reverse
          title="Tune in together"
          subtitle="Collaborate Effortlessly"
          description="Reviewing as a team is as simple as pressing play. Getting to know candidates is now more enjoyable than ever."
          imgSrc={FeaturedGif6}
        >
          <div className="featured-item-group without-label">
            <div className="featured-item-row">
              <label>Review Together</label>
            </div>

            <div className="featured-item-row">
              <img src={LeafYellow} alt="" />
              <p>Create shortlists that are easy to share.</p>
            </div>
            <div className="featured-item-row">
              <img src={LeafRed} alt="" />
              <p>Introduce candidates to hiring managers to keep everyone on the same page.</p>
            </div>
            <div className="featured-item-row">
              <img src={LeafBlue} alt="" />
              <p>
                Invite hiring managers, co-workers or clients to get to know candidates early in the
                process.
              </p>
            </div>
          </div>
        </FeaturedItem>
      </div>
    </section>
  )
}
